import { render, staticRenderFns } from "./cabinet-requests-list-new.vue?vue&type=template&id=307859f8&scoped=true"
import script from "./cabinet-requests-list-new.vue?vue&type=script&lang=js"
export * from "./cabinet-requests-list-new.vue?vue&type=script&lang=js"
import style0 from "./cabinet-requests-list-new.vue?vue&type=style&index=0&id=307859f8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307859f8",
  null
  
)

export default component.exports